module.exports = __webpack_public_path__ + "img/standard-lead-item-3.7a659f16.png";